import { State } from "../types/State";

export function getQueryFromState({
  "prix-min": prixMin,
  "prix-max": prixMax,
  "surface-min": surfaceMin,
  "code-postal": code,
  ville,
  "localite-range": range,
  ...state
}: State) {
  let query = `?${Object.entries(state)
    .map(([k, v]) => `${k}=${Array.isArray(v) ? v.join(",") : v}`)
    .join("&")}`;

  if (prixMin || prixMax)
    query += `&prix=${prixMin || 0}${prixMax ? `,${prixMax}` : ""}`;
  if (surfaceMin) query += `&surface=${surfaceMin}`;
  if (code && ville)
    query += `&ville=${code},${ville}${range ? `,${range}` : ""}`;

  return query;
}
